var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageMsgType } from '@tencent/dz-models';
import { useMessageModel, useConsultModel, useHeaderModel } from '../../hooks';
import { jsonParseSandbox } from '../../utils';
import { ReplyType } from '../../const';
import { useReportService } from './useReportService';
import styles from './index.less';
export var Recommend = function (props) {
    var message = props.message, type = props.type;
    var _a = useComponents(), View = _a.View, Text = _a.Text;
    var messageModel = useMessageModel();
    var headerModel = useHeaderModel();
    // 获取配置的转化页卡信息
    var consultModel = useConsultModel();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var recommend_question_config = consultModel.getConsultConfig().recommend_question_config;
    var report = useReportService(message.map(function (item) { return item.question; }), type);
    var onClickQuestion = function (item, index) {
        var _a;
        var recommendConfig = recommend_question_config ? jsonParseSandbox(recommend_question_config) : {};
        var isSentDirectly = recommendConfig.is_sent_directly || 2;
        if (messageModel.recommendDisabled)
            return;
        var isFeed = consultModel.isFeedConsult();
        if (isSentDirectly === 1 || isFeed) {
            // 直接发送
            messageModel.sendMessage(item.question, { inputType: 'click' });
            if (isFeed) {
                // 回复
                (_a = item === null || item === void 0 ? void 0 : item.replies) === null || _a === void 0 ? void 0 : _a.forEach(function (reply) {
                    var msgType = reply.type === 'IMAGE' ? MessageMsgType.Image : MessageMsgType.Text;
                    messageModel.sendServerMessage(reply.content, msgType);
                });
            }
        }
        else {
            // 将问题带入到输入框
            messageModel.updateInputMessage(item.question, true);
            // 更新发送框消息来源
            messageModel.updateInputMessageSource(__assign(__assign({}, report.reportModuleParams), { payload: {
                    reply_type: ReplyType.guess,
                    reply_content: item.question,
                } }));
            if (!isFeed) {
                // 关闭顶部卡片
                headerModel.updateIsShowTopCard(false);
            }
        }
        if (!isFeed) {
            // 点击问题后不再展示猜你想问
            messageModel.updateRecommendDisabled(true);
            // messageModel.deleteMessage(messageId);
        }
        // 点击问题上报
        report.recommendClick({ question: item.question, index: index });
    };
    return (React.createElement(View, { className: styles[type + "-card"] },
        React.createElement(View, { className: styles['recommend-title'] }, "\u731C\u4F60\u60F3\u95EE:"),
        message.map(function (item, index) { return (React.createElement(View, { className: styles['recommend-content-container'] + " " + (messageModel.recommendDisabled ? styles['recommend-content-container-disable'] : ''), onClick: function () { return onClickQuestion(item, index); }, key: index },
            React.createElement(Text, { className: styles['recommend-content'], content: item.question }))); })));
};
